<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg
          :site="site"
          text="news"
          :redirect_name="redirect_name"
        />
      </v-col>
    </v-row>

    <v-row class="pb-4">
      <v-col cols="12">
        <v-card elevation="0">
          <v-card-text class="py-0">
            <v-row justify="center">
              <v-col cols="12" md="6">
                <v-img :src="item.image"></v-img>
              </v-col>
              <v-col cols="12">
                <p class="text-h6 text--primary mx-0 text-start mb-0">
                  {{ item.title }}
                </p>
                <p class="text-content text--primary mx-0 text-start mb-0">
                  {{ item.sub_title }}
                </p>
                <p
                  class="text-content text--primary mx-0 text-start mb-0 mt-2 ql-editor"
                  style="height: fit-content"
                  v-html="formatHtmlDetail(item.detail)"
                ></p>
              </v-col>
            </v-row>
          </v-card-text> </v-card
      ></v-col>
    </v-row>
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import HeaderTextBg from "../../../components/headerTextBg.vue";
import { formatHtmlDetailDefault } from "../../../config/general-function.js";

export default {
  name: "Blog",
  components: { HeaderTextBg },
  data() {
    return {
      item: [],
      redirect_name: null,
      previousRouteName: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm คือตัวแทนของ this
      const currentRouteName = to.name;
      if (from?.fullPath && from?.fullPath !== "/") {
        sessionStorage.setItem(
          currentRouteName + "_prev_route_name",
          from.name
        );
        vm.previousRouteName = from.name;
      } else {
        vm.previousRouteName = sessionStorage.getItem(
          currentRouteName + "_prev_route_name"
        );
      }
      // ========== ========== ========== ==========
      if (!vm.previousRouteName) {
        vm.redirect_name = "all-blog";
      } else if (vm.previousRouteName != "all-blog") {
        vm.redirect_name = "main";
      }
    });
  },
  created() {
    this.getBlogDetail();
  },
  methods: {
    getBlogDetail() {
      Axios.get("site/getBlogDetail/" + this.$route.params.id).then(
        ({ data }) => {
          this.item = data.data;
        }
      );
    },
    formatHtmlDetail(value) {
      return formatHtmlDetailDefault(value);
    },
  },

  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
  filters: {},
};
</script>

<style scoped>
img {
  width: 100%;
  height: 100%;
}
</style>